export default Object.freeze({
  LOGIN: {
    name: 'Login',
    route: '/'
  },
  FORGOT_PASSWORD: {
    name: 'Forgot Password',
    route: '/forgot-password'
  },
  RESET_PASSWORD: {
    name: 'Reset Password',
    route: '/forgot-password/:token'
  },
  DASHBOARD: {
    name: 'Dashboard',
    route: '/dashboard'
  },
  INVITATION: {
    name: 'Invitation',
    route: '/onboarding/:code'
  },
});